/* eslint-disable */
import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { FILEURL, PUBLISH_REPORT, ENTITYNAME, OPERATORS, LOCALSTORAGE_KEY, MODULETYPES, SCHEDULETYPE, REPORT_TYPE, MEDIACATEGORIES, FILTER_CRITERIA_MEDIA_CONTENT_REPORT, PROMO_REPORT_FILTER, TOAST_TYPES } from "../../framework/constant/constant";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useNavigate } from "react-router-dom";
import { utility } from "../../framework/utility/utilityProvider";
import { useTranslation } from "../../locale/useTranslation";
import BossDialog from "../../components/BossDialog";
import { RadioButton } from "@progress/kendo-react-inputs";
import MyMultiSelect from "../../components/MyMultiSelect";
import ToastNotification from "../../components/ToastNotification";

const PromotionReport = (props) => {

    const defaultDates = utility.getFirstAndLastDateOfMonth();

    const blankDataItem = {
        MediaCategory: { SID: 0, Description: "All" },
        MediaCategoryType: { SID: 0, Description: "All" },
        FilterCriteria: {},
        FromDate: defaultDates.FirstDate,
        ToDate: defaultDates.LastDate,
        Channel: []
    }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const lang = useTranslation();
    const [mediaCategories, setMediaCategories] = useState([]);
    const [mediaCategoryTypes, setMediaCategoryTypes] = useState([]);
    const [filterMediaCategory, setFilterMediaCategory] = useState([]);
    const [filterMediaCategoryType, setFilterMediaCategoryType] = useState([{ SID: 0, Description: "All" }]);
    const [footerMessage, setFooterMessage] = useState('');
    const [filterCriterias, setFilterCriterias] = useState([]);
    const [selectAllChannels, setSelectAllChannels] = useState(false);
    const [channel, setChannel] = useState([]);
    const [isExporting, setIsExporting] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = async () => {
        let mediaCategoryRes = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { SID: 1 } });
        setMediaCategories([...mediaCategoryRes.data.filter((x) => x.SID != MEDIACATEGORIES.Series && x.SID != MEDIACATEGORIES.Season)
        ]);
        setFilterMediaCategory([
            { SID: 0, Description: "All" },
            ...mediaCategoryRes.data.filter((x) => !x.isLong && x.SID != MEDIACATEGORIES.Series && x.SID != MEDIACATEGORIES.Season)
        ]);

        const mediaCategoryTypeRes = await API.getDataLookup(ENTITYNAME.MediaCategoryType, { sort: { SID: 1 } });
        setMediaCategoryTypes([{ SID: 0, Description: "All" }, ...mediaCategoryTypeRes.data]);

        const filterCriteriaRes = Object.keys(PROMO_REPORT_FILTER).map(key => ({
            _id: PROMO_REPORT_FILTER[key],
            Description: key
        }));
        setFilterCriterias(filterCriteriaRes);

        const channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        channelRes.data.unshift({ _id: null, FullChannelName: "All" })
        setChannel(channelRes.data);
    }

    const isValid = () => {
        if (!utility.isValidDate(dataItem.FromDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
            return false;
        }
        if (!utility.isValidDate(dataItem.ToDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
            return false;
        }
        if (dataItem.ToDate < dataItem.FromDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_grater_then_from_date_error_message });
            return false;
        }
        if (!dataItem.Channel || dataItem.Channel.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }
        return true;
    };

    const loadAndExportData = async () => {
        if (!isValid()) return;
        setIsExporting(true);
        setFooterMessage(lang.please_wait_export_report_message);

        const payload = {
            mediaCategory: dataItem.MediaCategory?.SID ?? 0,
            mediaCategoryType: dataItem.MediaCategoryType?.SID ?? 0,
            FilterCriteria: dataItem?.FilterCriteria?._id,
            FromDate: dataItem?.FromDate ? utility.convertStringDatetoMilliseconds(dataItem?.FromDate) : null,
            ToDate: dataItem?.ToDate ? utility.convertStringDatetoMilliseconds(dataItem?.ToDate) : null,
            Channel: dataItem?.Channel?.length > 0 ? dataItem?.Channel?.map(x => x._id) : []
        };

        let res = await API.exportPromotionReport(payload);
        console.log(res);

        if (res.success) {
            setTimeout(() => {
                window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.content_report_is_exported_successfully_message });
                setFooterMessage(lang.content_report_is_exported_successfully_message);
            }, 5000);
            setIsExporting(false);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            setFooterMessage('');
        }

    }

    const onChange = async (e) => {
        if (e.target.name == "IsAllChannel") {
            setSelectAllChannels(!selectAllChannels);
            setDataItem({ ...dataItem, Channel: selectAllChannels ? [] : channel });
        } else if (e.target.name === "MediaCategory") {
            const selectedCategory = e.target.value;
            const filteredTypes = mediaCategoryTypes.filter((x) => x.MediaCategorySID === selectedCategory.SID);
            setFilterMediaCategoryType([{ SID: 0, Description: "All" }, ...filteredTypes]);
            setDataItem((prev) => ({ ...prev, MediaCategory: selectedCategory, MediaCategoryType: { SID: 0, Description: "All" } }));
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    return (<>
        {<BossDialog
            title={lang.promotion_report_header}
            onClose={() => navigate(-1)}
            width={"650px"}
        >
            <div className="row mt-2">
                <div className="col-6">
                    <div className="form-group">
                        <label htmlFor="TabView">{lang.media_category_label}</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={filterMediaCategory}
                            name="MediaCategory"
                            textField="Description"
                            dataItemKey="SID"
                            value={dataItem.MediaCategory}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group">
                        <label htmlFor="TabView">{lang.media_category_type_label}</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={filterMediaCategoryType}
                            name="MediaCategoryType"
                            textField="Description"
                            dataItemKey="SID"
                            value={dataItem.MediaCategoryType}
                            onChange={onChange}
                        />
                    </div>
                </div>
            </div>
            <div style={{ padding: "14px" }}>
                <div className="row border">
                    <div className="col-12 mb-2">
                        <div className="row mt-2">
                            <div className="col-6">
                                <label htmlFor="TabView">{lang.filter_criteria_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={filterCriterias}
                                    dataItemKey='_id'
                                    name='FilterCriteria'
                                    textField='Description'
                                    onChange={onChange}
                                    value={dataItem.FilterCriteria}
                                />
                            </div>
                            <div className="col-6">
                                <label htmlFor="TabView">{lang.channel_label} *</label>
                                <span className="float-right">{lang.select_all_label}
                                    <input
                                        type="checkbox"
                                        name="IsAllChannel"
                                        className="ml-1"
                                        value={selectAllChannels}
                                        checked={selectAllChannels}
                                        onChange={onChange}
                                    />
                                </span>
                                <MyMultiSelect
                                    style={{ backgroundColor: "white" }}
                                    data={channel}
                                    name="Channel"
                                    textField="FullChannelName"
                                    dataItemKey="_id"
                                    value={dataItem.Channel}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-6">
                                <label htmlFor="TabView">{lang.from_date_label} *</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="FromDate"
                                    type="date"
                                    value={dataItem.FromDate}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="col-6">
                                <label htmlFor="TabView">{lang.to_date_label} *</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="ToDate"
                                    type="date"
                                    value={dataItem.ToDate}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row" style={{ marginTop: "5px" }}>
                <div className="col-12">
                    <ActionButton title={lang.export_button_tooltip} name={lang.export_button_text} onClick={loadAndExportData} style={{ margin: '0px', borderRadius: '5px' }} />
                </div>
            </div>

            <div className='text-right mt-3' style={{ position: 'fixed', height: '30px', width: '652px', marginLeft: '-20px', padding: '5px', background: "#3A3633" }}>
                <span style={{ color: 'white' }}>{footerMessage} </span>
            </div>
        </BossDialog>}
    </>)
}
export default PromotionReport;